// Explore-stats page: Levels of qualifications — current Parliament.
// Recreates the Handbook page — horizontal stacked bar of qualification
// levels by party, with a supporting level/total table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatStackedBar } from './charts';

export default function LevelsOfQualifications() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('levels-of-qualifications');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Levels of qualifications — current Parliament"
      description="The levels of qualification held by current parliamentarians — a high number of Bachelor degrees and comparatively few at other levels such as Doctorate. “None” counts parliamentarians with no recorded qualifications."
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="levels-of-qualifications"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Level of qualifications — current Parliament
          </Typography>
          <StatStackedBar
            data={charts.by_level_party || []}
            xKey="level"
            keys={charts.series || []}
            layout="vertical"
            height={420}
          />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
